import { useEffect } from "react";

/**
 * Notify parent embed.js popup to resize iframe to content height.
 */
export function useEmbedHeightSync(enabled, deps = []) {
  useEffect(() => {
    if (!enabled || typeof window === "undefined" || !window.parent) return undefined;

    const postHeight = () => {
      const height = Math.ceil(
        Math.max(
          document.documentElement.scrollHeight,
          document.body?.scrollHeight || 0
        )
      );
      window.parent.postMessage(
        { pivonyFeedback: "resize", height },
        "*"
      );
    };

    postHeight();

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(postHeight);
      ro.observe(document.documentElement);
      if (document.body) ro.observe(document.body);
    } else {
      window.addEventListener("resize", postHeight);
    }

    return () => {
      if (ro) ro.disconnect();
      else window.removeEventListener("resize", postHeight);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);
}
